import { DOMAttributes } from 'react';
import type { Moment } from 'moment';
import { UseFormReturn } from 'react-hook-form';

import { Action } from 'shared/types';

export const DEFAULT_REWARD_UNIT = 'USD';
export const DEFAULT_USD_REWARD_AMOUNT = 10;
export const MIN_USD_REWARD_AMOUNT = 5;
export const DEFAULT_TREE_REWARD_ORGANIZATION = 'One Tree Planted';

export type FormFieldValues = {
  title: string;
  subTitle: string;
  description: string;
  bannerImage: string;
  status: string;
  rewardUnit: string;
  rewardAmount: number;
  impactUnit: string | null;
  impactAmount: number;
  causes: Action['Causes'];
  categories: string[];
  sdgs: string[];
  campaignIds?: string[];
  nonprofitId?: string | null;
  nonprofit?: { id: string; name: string } | null;
  startingAt?: Moment | string | null;
  endingAt?: Moment | string | null;
  enabled?: boolean;
  public?: boolean;
};

export interface ActionFormProps {
  title: string;
  formMethods: UseFormReturn<FormFieldValues>;
  handleSubmit: DOMAttributes<HTMLFormElement>['onSubmit'];
  isLoading: boolean;
  actionHasActivities?: boolean;
  treeNonprofit?: { id: string; name: string };
  showSDGs: boolean;
  showDates: boolean;
  showSelectNonprofit: boolean;
  showCampaignTip: boolean;
  showSelectVisibility: boolean;
  backLink: string;
}
